<template>
    <div class="table-resultado-row" v-bind="gridRowProperties" id="resultado-detail-card">
        <div :class="'resultado-detail-card d-inline-flex detail-card-bg-' + cardBg" v-bind="cardDetailsProperties">
            <h6 @click="showRequester = !showRequester; showRegOff = false; showOrder = false;" style="cursor: pointer">
                Informações do Solicitante
                <font-awesome-icon :icon=iconRequester size="xs" fixed-width/>
            </h6>
            <div class="resultado-detail-card-block" v-for="(block, idx) in detailCardFields.requester" :key="idx" v-show="showRequester">
                <div class="resultado-detail-column" v-for="(column, ix) in block" :key="ix">
                    <span v-for="(element, i) in column" :key="i">
                        <b>{{element.label}} </b>
                        <template v-if="item[element.key]">
                            {{ element.maskDoc ? maskCpfCnpj(item[element.key]) : null }}
                            {{ element.isCurrency ? formatCurrency(item[element.key]) : null }}
                            {{ element.isDate ? formatDate(item[element.key]) : null }}
                            {{ element.isFullDate ? formatDateHour(item[element.key]) : null }}
                            {{ element.telephone ? telefone(item[element.key]) : null }}
                            {{ element.zipCode ? cep(item[element.key]) : null }}
                            {{ !element.zipCode && !element.maskDoc && !element.isCurrency && !element.isDate && !element.telephone && !element.isFullDate ? item[element.key] : null }}
                        </template>
                        <template v-else>&mdash;</template>
                    </span>
                </div>
            </div>
            <h6 @click="showRegOff = !showRegOff; showRequester = false; showOrder = false;" style="cursor: pointer">
                Informações do Cartório {{ item.tipoCartorio && item.tipoCartorio == 'D' ? ' - Aguardando distribuição' : null }}
                <font-awesome-icon :icon=iconRegOff size="xs" fixed-width v-if="(item.tipoCartorio && item.tipoCartorio == 'C') || !item.tipoCartorio"/>
            </h6>
            <div class="resultado-detail-card-block" v-for="(block, idx) in detailCardFields.regOff" :key="idx" v-show="showRegOff">
                <div class="resultado-detail-column" v-for="(column, ix) in block" :key="ix">
                    <span v-for="(element, i) in column" :key="i">
                        <b>{{element.label}} </b>
                        <template v-if="item[element.key]">
                            {{ element.maskDoc ? maskCpfCnpj(item[element.key]) : null }}
                            {{ element.isCurrency ? formatCurrency(item[element.key]) : null }}
                            {{ element.isDate ? formatDate(item[element.key]) : null }}
                            {{ element.isFullDate ? formatDateHour(item[element.key]) : null }}
                            {{ element.telephone ? telefone(item[element.key]) : null }}
                            {{ element.zipCode ? cep(item[element.key]) : null }}
                            {{ !element.zipCode && !element.maskDoc && !element.isCurrency && !element.isDate && !element.telephone && !element.isFullDate ? item[element.key] : null }}
                        </template>
                        <template v-else>&mdash;</template>
                    </span>
                </div>
            </div>
            <h6 @click="showOrder = !showOrder; showRegOff = false; showRequester = false;" style="cursor: pointer">
                Informações do Pedido
                <font-awesome-icon :icon=iconOrder size="xs" fixed-width/>
            </h6>
            <div class="resultado-detail-card-block" v-for="(block, idx) in detailCardFields.order" :key="idx" v-show="showOrder">
                <div class="resultado-detail-column" v-for="(column, ix) in block" :key="ix">
                    <span v-for="(element, i) in column" :key="i">
                        <b>{{element.label}} </b>
                        <template v-if="item[element.key]">
                            {{ element.maskDoc ? maskCpfCnpj(item[element.key]) : null }}
                            {{ element.isCurrency ? formatCurrency(item[element.key]) : null }}
                            {{ element.isDate ? formatDate(item[element.key]) : null }}
                            {{ element.isFullDate ? formatDateHour(item[element.key]) : null }}
                            {{ element.telephone ? telefone(item[element.key]) : null }}
                            {{ element.zipCode ? cep(item[element.key]) : null }}
                            {{ !element.zipCode && !element.maskDoc && !element.isCurrency && !element.isDate && !element.telephone && !element.isFullDate ? item[element.key] : null }}
                        </template>
                        <template v-else>{{ element.label ? '&mdash;' : '&nbsp;'}}</template>
                    </span>
                </div>
            </div>
            <div class="resultado-detail-card-block block-status" v-if="[page].indexOf('Painel', 'aprovadas', 'VisualizarPedidoProtesto') >= 0">
                <div v-show="page==='Painel'" class="resultado-detail-button">
                </div>
                <div v-show="page==='aprovadas'" class="resultado-detail-status-button">
                    <!-- <button v-bind:style="blueButtonStyle.style" v-html="blueButtonStyle.content"></button> -->
                </div>
                <div v-show="page==='VisualizarPedidoProtesto'" class="resultado-detail-status-button">
                    <div class="detail-status-bar">Status: {{status}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        props:{
            item: { type: [Array, Object], default: [] },
            status: { type: String, default: '' },
            page: { type: String },
            gridRowProperties: {type: Object, default: {} },
            rowWidth: { type: [String, Number], default: '' },
            detailCardFields: { type: [Object, Array], default: [] },
        },
        filters:{},
        data() {
            return {
                cardDetailsProperties:{},
                blueButtonStyle:{
                    content:'Solicitar anuência',
                    style:{}
                },
                currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}),
                showRequester: false,
                showOrder: false,
                showRegOff: false,
            }
        },
        methods: {
            maskCpfCnpj: function (cpfCnpj){
                if (!cpfCnpj) return ''
                cpfCnpj = cpfCnpj.replace(/\D/g, '')
                if(cpfCnpj.length < 14) return cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
                else return cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
            },
            formatDate(date){
                if (date !== "" && date !== undefined && date !== null) {
                    let formattedDate = new Date(date);
                    return formattedDate.toLocaleDateString("pt-BR", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                    });
                }
                return "";
            },
            formatDateHour(date){
                if (!date) return ''
                
                let formattedDate = new Date(date);
                return formattedDate.toLocaleDateString("pt-BR", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                });
            },
            formatCurrency(currency){
                if(!currency) currency = 0
                return this.currencyFormatter.format(currency);
            },
            cep: function(numero){
                if (!numero) return ''
                numero = (numero + '').trim().replace(/\D/g, '')
                if (numero.length < 8) numero = numero.padStart(8, '0')
                return numero.replace(/(\d{5})(\d{3})/, '$1-$2')
            },
            telefone: function (numero){
                if (!numero) return '-'
                return numero.trim().replace(/\D+/gi, '').replace(/(\d{2})(\d{4,5})(\d{4})/g, '($1) $2-$3')
            },
        },
        mounted() {
            this.cardDetailsProperties.style={'width':this.rowWidth + 'px'}
        },
        computed: {
            cardBg: function() {
                switch (this.status) {
                    case 'Pedido enviado. Aguardando orçamento':
                    case 'Comprovante enviado ao cartório.':
                    case 'Protesto cancelado':
                    case 'Protestado':
                        return 'F2F6FE' // azul
                    case 'Aguardando pagamento':
                        return 'FEFDF2' // amarelo
                    case 'Concluído':
                        return 'F2FEF6' // verde
                    case 'Cancelado':
                    case 'Pedido rejeitado':
                        return 'FEF2F2' // vermelho
                    case 'Aguardando orçamento':
                        return 'FFFFFF' // branco
                    default:
                        return 'F2F6FE' // azul
                }
            },
            iconRequester: function (){
                return this.showRequester ? 'caret-square-up': 'caret-square-down'
            },
            iconRegOff: function (){
                return this.showRegOff ? 'caret-square-up': 'caret-square-down'
            },
            iconOrder: function (){
                return this.showOrder ? 'caret-square-up': 'caret-square-down'
            },
        }
    }
</script>
<style>
.resultado-detail-card {display: flex;flex-flow: column;grid-column: 1/-1;padding: 12px 22px 26px 22px;}
    .resultado-detail-card.detail-card-bg-F2F6FE {background: #F2F6FE 0% 0% no-repeat padding-box;} /**    AZUL    **/
    .resultado-detail-card.detail-card-bg-FEFDF2 {background: #FEFDF2 0% 0% no-repeat padding-box;} /**  AMARELO   **/
    .resultado-detail-card.detail-card-bg-F2FEF6 {background: #F2FEF6 0% 0% no-repeat padding-box;} /**   VERDE    **/
    .resultado-detail-card.detail-card-bg-FEF2F2 {background: #FEF2F2 0% 0% no-repeat padding-box;} /**  VERMELHO  **/
    .resultado-detail-card.detail-card-bg-FFFFFF {background: #FFFFFF 0% 0% no-repeat padding-box;} /**   BRANCO   **/
.resultado-detail-card .resultado-detail-card-block {display: flex;flex-flow: wrap;padding-bottom: 3px;margin-bottom: 10px;}
.resultado-detail-card .resultado-detail-card-block:not(:last-child) {border-bottom: 1px solid black;}
    .resultado-detail-card.detail-card-bg-F2F6FE .resultado-detail-card-block:not(:last-child) {border-color: #CBD6F8;} /**    AZUL    **/
    .resultado-detail-card.detail-card-bg-FEFDF2 .resultado-detail-card-block:not(:last-child) {border-color: #F8F5CB;} /**  AMARELO   **/
    .resultado-detail-card.detail-card-bg-F2FEF6 .resultado-detail-card-block:not(:last-child) {border-color: #CBF8D8;} /**   VERDE    **/
    .resultado-detail-card.detail-card-bg-FEF2F2 .resultado-detail-card-block:not(:last-child) {border-color: #F8CBCB;} /**  VERMELHO  **/
    .resultado-detail-card.detail-card-bg-FFFFFF .resultado-detail-card-block:not(:last-child) {border-color: #F1F1F1;} /**   BRANCO   **/
.resultado-detail-card-block .resultado-detail-column {display: flex;flex-flow: column;flex: 1 1 33%;max-width: 33%;}
.resultado-detail-card-block .resultado-detail-column span {font: normal normal normal 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;margin-bottom: 9px;}

.resultado-detail-card-block.block-status{margin: 0;padding: 0;}
    .block-status .resultado-detail-status-button{width: 100%;display: flex;justify-content: flex-end;}
        .block-status .resultado-detail-status-button .detail-status-bar{flex:1;font: normal normal bold 15px/20px 'Kanit', sans-serif; padding: 15px 17px;border-radius: 5px;}
        .resultado-detail-card.detail-card-bg-F2F6FE .resultado-detail-status-button .detail-status-bar{background-color: #CBD6F8;color:#4780F1;} /**    AZUL    **/
        .resultado-detail-card.detail-card-bg-FEFDF2 .resultado-detail-status-button .detail-status-bar{background-color: #F8F5CB;color:#706927;} /**  AMARELO   **/
        .resultado-detail-card.detail-card-bg-F2FEF6 .resultado-detail-status-button .detail-status-bar{background-color: #CBF8D8;color:#27703C;} /**   VERDE    **/
        .resultado-detail-card.detail-card-bg-FEF2F2 .resultado-detail-status-button .detail-status-bar{background-color: #F8CBCB;color:#702727;} /**  VERMELHO  **/
        .resultado-detail-card.detail-card-bg-FFFFFF .resultado-detail-status-button .detail-status-bar{background-color: #F1F1F1;color:#707070;} /**   BRANCO   **/
        .block-status .resultado-detail-status-button button{width: 167px;height: 49px;display: flex;justify-content: center;cursor: pointer;align-items: center;background: #F2F6FE 0% 0% no-repeat padding-box;border: 3px solid #4780F1;border-radius: 5px;text-align: left;font: normal normal bold 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #4780F1;margin-left:30px;}
                .block-status .resultado-detail-status-button button:hover{background-color: #4780F1;color:white}
</style>